<div class="sidebar" id="right-sidebar-filter">
  @if (!isRightSidebarHidden()) {
    <vectronic-card
      title="{{ title() }}"
      [displayClose]="true"
      (closed)="toggleRightSidebarVisibility()"
      [closeIcon]="'chevron_right'"
    >
      <ng-container body>
        <ng-content></ng-content>
      </ng-container>
    </vectronic-card>
  }
  @if (isRightSidebarHidden()) {
    <button
      mat-button
      class="toggle-sidebar-button"
      (click)="toggleRightSidebarVisibility()"
      [ngClass]="router.url === '/map' || router.url === '/commands' ? 'bg-white' : 'bg-gray'"
    >
      <mat-icon class="mr-0">{{ isRightSidebarHidden ? 'arrow_back' : 'arrow_forward' }}</mat-icon>
    </button>
  }
</div>
